import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../../Miscelania/RequestApi';

// Helpers de formulário
import Toggle from 'react-toggle';
import getLocale from '../../../i18n/getLocale';

// Importo o moment com a linguagem pt-br
require('moment');
require('moment/locale/pt-br');

class TrainingSimulatorStaffResult extends Component {
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed',        
      },
      redirect_url: false,
      loaded: 0,
      id: this.props.training_certification_staff_id,
      date_start: this.props.date_start,
      date_finish: this.props.date_finish,
      pnf: this.props.pnf,
      certification_id: this.props.certification_id,
      hours: this.props.hours,
      result: this.props.result,
      finalized: 0,
    };

    this.locale = getLocale();

    //bind específico
    this.changeFinalized = this.changeFinalized.bind(this);
  }

  // Handlers
  handleChange (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  } 

  handleToggleChangeFinalized (name, event) {
    var change = {};
    if (event.target.checked === true) {
      var value = 1;
    } else {
      var value = 0;
    }
    change[name] = value;
    this.setState(change);
    this.changeFinalized(value);
  } 

  // LM
  componentWillReceiveProps(newProps) {
    if(typeof newProps.training_certification_staff_id !== 'undefined'){
      this.setState({
        hours: newProps.hours,
        result: newProps.result,
        finalized: newProps.finalized,
        date_start: newProps.date_start,
        date_finish: newProps.date_finish,
        pnf: newProps.pnf,
        certification_id: newProps.certification_id,
        id: newProps.training_certification_staff_id,
        loaded: 1,
      });
    }
  }
  
  // Fetch salvando a edição
  changeFinalized(value) {
    this.props.handleAlert('', '', 'open');
    var datasave = {
      id: this.state.id,
      finalized: value,
    };
    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/treinamento/certificado/tripulante/finalizar', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        self.props.updateData(responseJson);
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  render() {
    var self = this;
    return (
      <div>
        <RequestApi ref={'request_api'} />
        <table className="table">
          <thead>
            <tr>
              <th className="text-center">{this.locale.Treinamentos.EditarTreinamento.tabResultados.tabelaTripulantes.HoraPF}</th>
              <th className="text-center">{this.locale.Treinamentos.EditarTreinamento.tabResultados.tabelaTripulantes.HoraPNF}</th>
              <th className="text-center" width="236">{this.locale.Treinamentos.EditarTreinamento.tabResultados.tabelaTripulantes.Finalizado}?</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>
                {this.state.hours}
              </td>
              <td>
                {this.state.pnf}
              </td>
              <td>
                <Toggle
                  checked={this.state.finalized}
                  aria-label='No label tag'
                  name="finalized"
                  onChange={this.handleToggleChangeFinalized.bind(this, 'finalized')}
                  disabled={this.state.finalized === 1 ? "disabled" : ""} />
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    );
  }
}

export default TrainingSimulatorStaffResult;



// WEBPACK FOOTER //
// ./src/Components/Trainings/Elements/TrainingSimulatorStaffResult.js